import React from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { addOrgAction, orgsListAction, deleteOrgAction, updateOrgAction, updateOrgLogoAction } from '../../redux/actions/orgActions';
import { ADD_ORG_RESET, DELETE_ORG_RESET, UPDATE_ORG_RESET } from '../../redux/constants/orgConstants';

import Content from '../../components/Content';
import OrgListTable from './OrgListTable';
import Pagination from '../../components/Pagination';
import AddOrgModal from './AddOrgModal';
import DeleteOrgModal from './DeleteOrgModal';
import ResetPasswordModal from './ResetPasswordModal';
import ToggleOrgActive from './ToggleOrgActive';
import { resetPasswordAction, toggleUserActive } from '../../redux/actions/userActions';
import { RESET_USER_PASSWORD_RESET, UPDATE_USER_STATUS_RESET } from '../../redux/constants/userConstants';

const OrgsScreen = ({ history }) => {
  const dispatch = useDispatch();

  const [searchKey, setSearchKey] = React.useState('');
  // const [ startValue, setStartValue ] = React.useState(1);
  // const [ endValue, setEndValue ] = React.useState(1);
  const [totalPageSize, setTotalPageSize] = React.useState(0);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageLimit = 15;

  // Add or update org states
  const [addOrgModal, setAddOrgModal] = React.useState(false);
  const [editOrgData, setEditOrgData] = React.useState({});
  const [orgName, setOrgName] = React.useState({ value: '', error: '' });
  const [orgEmail, setOrgEmail] = React.useState({
    value: '',
    error: '',
  });
  const [orgPhone, setOrgPhone] = React.useState({
    value: '',
    error: '',
  });
  const [orgAddress, setOrgAddress] = React.useState({
    value: '',
    error: '',
  });
  const [orgLogo, setOrgLogo] = React.useState({ value: '', error: '' });
  const [customClientData, setCustomClientData] = React.useState({
    space: {
      value: '',
      error: '',
    },
    adminUsers: {
      value: '',
      error: '',
    },
    downloadUsers: {
      value: '',
      error: '',
    },
  });
  const [orgModules, setOrgModules] = React.useState({
    fileSharing: true,
    chat: false,
    adminOnlyChat: false,
    videoCall: false,
    websiteForms: false,
  });

  // Reset password states
  const [resetPasswordModal, setResetPasswordModal] = React.useState(false);
  const [resetPasswordData, setResetPasswordData] = React.useState({});
  const [resetPassword, setResetPassword] = React.useState({
    value: '',
    error: '',
  });
  const [resetPasswordConfirm, setResetPasswordConfirm] = React.useState({
    value: '',
    error: '',
  });

  // Delete Org states
  const [toggleOrgModal, setToggleOrgModal] = React.useState(false);
  const [deleteOrgModal, setDeleteOrgModal] = React.useState(false);
  const [deleteOrgData, setDeleteOrgData] = React.useState({});
  const [deleteEmail, setDeleteEmail] = React.useState({
    value: '',
    error: '',
  });

  const userLogin = useSelector(state => state.userLogin);
  const orgsList = useSelector(state => state.orgsList);
  const addOrg = useSelector(state => state.addOrg);
  const updateOrg = useSelector(state => state.updateOrg);
  const deleteOrg = useSelector(state => state.deleteOrg);
  const updateUserStatus = useSelector(state => state.updateUserStatus);
  const resetUserPassword = useSelector(state => state.resetUserPassword);

  React.useEffect(() => {
    if (userLogin && userLogin.userInfo && userLogin.userInfo.data && userLogin.userInfo.data.user && userLogin.userInfo.data.user.role !== 'admin') {
      history.push('/');
    }
  }, [userLogin, history]);

  // ============================== Get Clients End ======================================
  React.useEffect(() => {
    dispatch(orgsListAction(pageNumber, pageLimit));
  }, [dispatch, pageNumber]);

  React.useEffect(() => {
    if (orgsList && orgsList.orgs && orgsList.orgs.status === 'success' && orgsList.orgs.data && orgsList.orgs.data.data) {
      setTotalPageSize(orgsList.orgs.totalResults);
    }
  }, [orgsList]);

  const handlePageChange = async currentPage => {
    setPageNumber(currentPage.selected + 1);
    // setStartValue(currentPage.selected + 1 * pageNumber);
    // setEndValue(startValue + pageLimit);
  };

  // ============================== Get Clients End ======================================

  // ============================== ADD/UPDATE Client Start ======================================
  React.useEffect(() => {
    if (editOrgData && editOrgData._id) {
      setOrgName({ value: editOrgData.name });
      setOrgEmail({ value: editOrgData.email });
      setOrgPhone({ value: editOrgData.phone });
      setOrgAddress({ value: editOrgData.address });
      editOrgData.modules &&
        setOrgModules({
          fileSharing: editOrgData.modules.fileSharing,
          chat: editOrgData.modules.chat,
          videoCall: editOrgData.modules.videoCall,
          adminOnlyChat: editOrgData.modules.adminOnlyChat,
          websiteForms: editOrgData.modules.websiteForms,
        });
      if (editOrgData.customClient && editOrgData.customClientDetails) {
        setCustomClientData({
          space: { value: editOrgData.customClientDetails.space, error: '' },
          adminUsers: {
            value: editOrgData.customClientDetails.adminUsers,
            error: '',
          },
          downloadUsers: {
            value: editOrgData.customClientDetails.downloadUsers,
            error: '',
          },
        });
      }
    }
  }, [editOrgData]);

  const uploadOrgLogo = React.useCallback(
    async id => {
      if (orgLogo.value !== '') {
        const formData = new FormData();
        formData.append('logo', orgLogo.value);
        const data = await dispatch(updateOrgLogoAction(id, formData));
        if (data && data.status === 'success') {
          dispatch(orgsListAction(pageNumber, pageLimit));
        }
      } else {
        dispatch(orgsListAction(pageNumber, pageLimit));
      }
    },
    [dispatch, orgLogo, pageNumber]
  );

  React.useEffect(
    () => {
      if (addOrg && addOrg.data && addOrg.data.status === 'success') {
        uploadOrgLogo(addOrg.data.data.data._id);
        toast.success(addOrg.data.message);
        handleAddModalClose();
        dispatch({ type: ADD_ORG_RESET });
      } else if (addOrg && addOrg.error && addOrg.error.status === 'fail') {
        toast.error(addOrg.error.msg);
        dispatch({ type: ADD_ORG_RESET });
        // } else {
        //   toast.error('Something went wrong, please try again later');
        //   dispatch({ type: ADD_ORG_RESET });
      }
    },
    //eslint-disable-next-line
    [addOrg, dispatch, orgLogo, uploadOrgLogo]
  );

  React.useEffect(
    () => {
      if (updateOrg && updateOrg.org && updateOrg.org.status === 'success') {
        uploadOrgLogo(updateOrg.org.data.data._id);
        toast.success('Client update successfull!');
        handleAddModalClose();
        dispatch({ type: UPDATE_ORG_RESET });
      }
    },
    //eslint-disable-next-line
    [updateOrg, dispatch, uploadOrgLogo]
  );

  const handleEditOrgButtonClick = data => {
    setEditOrgData(data);
    setAddOrgModal(true);
  };

  const handleAddOrg = () => {
    if (orgName.value === '' || orgName.value.trim() === '') {
      setOrgName({ ...orgName, error: 'Please enter client name' });
    } else if (orgEmail.value === '' || orgEmail.value.trim() === '') {
      setOrgEmail({ ...orgEmail, error: 'Please enter client email' });
    } else if (orgPhone.value === '' || orgPhone.value.trim() === '') {
      setOrgPhone({ ...orgPhone, error: 'Please enter client phone' });
    } else if (orgAddress.value === '' || orgAddress.value.trim() === '') {
      setOrgAddress({
        ...orgAddress,
        error: 'Please enter client address',
      });
    } else {
      if (editOrgData && editOrgData._id) {
        const data = {
          name: orgName.value,
          email: orgEmail.value,
          phone: orgPhone.value,
          address: orgAddress.value,
          modules: orgModules,
        };

        if (editOrgData.customClient && editOrgData.customClientDetails) {
          if (customClientData.space.value === '') {
            setCustomClientData({
              ...customClientData,
              space: {
                ...customClientData.space,
                error: 'Please allocate client some space to upload data.',
              },
            });
          } else if (customClientData.adminUsers.value === '') {
            setCustomClientData({
              ...customClientData,
              adminUsers: {
                ...customClientData.adminUsers,
                error: 'Please enter client admin users.',
              },
            });
          } else if (customClientData.downloadUsers.value === '') {
            setCustomClientData({
              ...customClientData,
              downloadUsers: {
                ...customClientData.downloadUsers,
                error: 'Please enter client file users.',
              },
            });
          } else {
            data.customClientDetails = {
              adminUsers: Number(customClientData.adminUsers.value),
              downloadUsers: Number(customClientData.downloadUsers.value),
              space: Number(customClientData.space.value),
            };
            dispatch(updateOrgAction(editOrgData._id, data));
          }
        } else {
          dispatch(updateOrgAction(editOrgData._id, data));
        }
      } else {
        if (customClientData.space.value === '') {
          setCustomClientData({
            ...customClientData,
            space: {
              ...customClientData.space,
              error: 'Please allocate client some space to upload data.',
            },
          });
        } else if (customClientData.adminUsers.value === '') {
          setCustomClientData({
            ...customClientData,
            adminUsers: {
              ...customClientData.adminUsers,
              error: 'Please enter client admin users.',
            },
          });
        } else if (customClientData.downloadUsers.value === '') {
          setCustomClientData({
            ...customClientData,
            downloadUsers: {
              ...customClientData.downloadUsers,
              error: 'Please enter client admin users.',
            },
          });
        } else {
          const data = {
            name: orgName.value,
            email: orgEmail.value,
            phone: orgPhone.value,
            address: orgAddress.value,
            modules: orgModules,
            customClientDetails: {
              adminUsers: Number(customClientData.adminUsers.value),
              downloadUsers: Number(customClientData.downloadUsers.value),
              space: Number(customClientData.space.value),
            },
          };
          console.log(data, 'data');
          dispatch(addOrgAction(data));
        }
      }
    }
  };

  const handleAddModalClose = () => {
    setAddOrgModal(false);
    setEditOrgData({});
    setOrgName({ value: '', error: '' });
    setOrgEmail({ value: '', error: '' });
    setOrgPhone({ value: '', error: '' });
    setOrgAddress({ value: '', error: '' });
    setOrgLogo({ value: '', error: '' });
    setOrgModules({ fileSharing: false, chat: false, videoCall: false, adminOnlyChat: false });
    setCustomClientData({
      space: {
        value: '',
        error: '',
      },
      adminUsers: {
        value: '',
        error: '',
      },
      downloadUsers: {
        value: '',
        error: '',
      },
    });
  };
  // ============================== ADD/UPDATE Client End ======================================

  // ============================== Reset Client Password Start ======================================
  React.useEffect(() => {
    if (resetUserPassword && resetUserPassword.userInfo && resetUserPassword.userInfo.status === 'Success') {
      toast.success('Client password reset successfull.');
      handleResetPasswordModalClose();
      dispatch(orgsListAction(pageNumber, pageLimit));
      dispatch({ type: RESET_USER_PASSWORD_RESET });
    }
  }, [resetUserPassword, dispatch, pageNumber]);

  const handleResetPasswordButtonClick = data => {
    setResetPasswordData(data);
    setResetPasswordModal(true);
  };

  const handleResetPassword = () => {
    if (resetPassword.value === '' || resetPassword.value.trim() === '') {
      setResetPassword({
        ...resetPassword,
        error: 'Please enter new password',
      });
    } else if (resetPassword.value.length < 8) {
      setResetPassword({
        ...resetPassword,
        error: 'Password must have atleast 8 characters',
      });
    } else if (resetPasswordConfirm.value === '' || resetPasswordConfirm.value.trim() === '') {
      setResetPasswordConfirm({
        ...resetPasswordConfirm,
        error: 'Please confirm new password',
      });
    } else if (resetPassword.value !== resetPasswordConfirm.value) {
      setResetPasswordConfirm({
        ...resetPasswordConfirm,
        error: 'Passwords do not match',
      });
    } else {
      if (resetPasswordData && resetPasswordData._id) dispatch(resetPasswordAction(resetPasswordData._id, resetPassword.value));
      else
        setResetPasswordConfirm({
          ...resetPasswordConfirm,
          error: 'Please select client to reset password',
        });
    }
  };

  const handleResetPasswordModalClose = () => {
    setResetPasswordModal(false);
    setResetPasswordData({});
    setResetPassword({ value: '', error: '' });
    setResetPasswordConfirm({ value: '', error: '' });
  };
  // ============================== Reset Client Password End ======================================

  // ============================== Toggle Client Start ======================================
  React.useEffect(() => {
    if (updateUserStatus && updateUserStatus.userInfo && updateUserStatus.userInfo.status === 'success') {
      toast.error('Client status change successfull.');
      handleToggleModalClose();
      dispatch(orgsListAction(pageNumber, pageLimit));
      dispatch({ type: UPDATE_USER_STATUS_RESET });
    }
  }, [updateUserStatus, pageNumber, dispatch]);

  const handleToggleButtonClick = data => {
    setDeleteOrgData(data);
    setToggleOrgModal(true);
  };

  const handleOrgToggle = (id, active) => {
    dispatch(toggleUserActive(id, !active));
  };

  const handleToggleModalClose = () => {
    setToggleOrgModal(false);
    setDeleteOrgData({});
  };
  // ============================== Toggle Client End ======================================

  // ============================== Delete Client Start ======================================
  React.useEffect(
    () => {
      if (deleteOrg && deleteOrg.org && deleteOrg.org.status === 'success') {
        toast.error('Delete Client Successful');
        handleDeleteOrgModalClose();
        dispatch(orgsListAction(pageNumber, pageLimit));
        dispatch({ type: DELETE_ORG_RESET });
      }
    },
    //eslint-disable-next-line
    [deleteOrg, dispatch, pageNumber]
  );

  const handleDeleteOrgButtonClick = data => {
    setDeleteOrgData(data);
    setDeleteOrgModal(true);
  };

  const handleDeleteOrg= () => {
    if (deleteEmail.value === '' || deleteEmail.value.trim() === '') {
      setDeleteEmail({
        ...deleteEmail,
        error: 'Please enter client email to delete',
      });
    } else if (deleteOrgData && deleteEmail.value !== deleteOrgData.email) {
      setDeleteEmail({ ...deleteEmail, error: 'Invalid email entered' });
    } else {
      if (deleteOrgData && deleteOrgData._id) dispatch(deleteOrgAction(deleteOrgData._id));
      else
        setDeleteEmail({
          ...deleteEmail,
          error: 'Please select client to delete',
        });
    }
  };

  const handleDeleteOrgModalClose = () => {
    setDeleteOrgModal(false);
    setDeleteOrgData({});
    setDeleteEmail({ value: '', error: '' });
  };
  // ============================== Delete Client End ======================================

  return (
    <Content
      headerTitle='Clients'
      currentMenu='orgs'
      addBtn={true}
      addBtnTitle='Add Client'
      addBtnClick={() => setAddOrgModal(true)}
      searchBox={true}
      searchPlaceholder='Search Clients'
      handleSearchChange={e => setSearchKey(e.target.value)}
      totalReult={totalPageSize !== 0 ? totalPageSize + ' orgs' : ''}
    >
      <OrgListTable
        orgsList={orgsList}
        searchKey={searchKey}
        handleToggleButtonClick={handleToggleButtonClick}
        handleResetPasswordButtonClick={handleResetPasswordButtonClick}
        handleEditOrgButtonClick={handleEditOrgButtonClick}
        handleDeleteOrgButtonClick={handleDeleteOrgButtonClick}
      />

      <div className='table__footer'>
        {/* <p className='table__footer_text'>
					Showing {startValue} - {endValue} results out of {totalPageSize} clients
				</p> */}
        <p />
        <Pagination onPageChange={handlePageChange} rowsPerPage={pageLimit} totalPageSize={totalPageSize} pageNumber={pageNumber} />
      </div>

      <AddOrgModal
        addOrgModal={addOrgModal}
        handleAddOrg={handleAddOrg}
        handleAddModalClose={handleAddModalClose}
        createOrgLoading={addOrg && addOrg.loading}
        updateOrgLoading={updateOrg && updateOrg.loading}
        data={{
          orgName,
          setOrgName,
          orgEmail,
          setOrgEmail,
          orgPhone,
          setOrgPhone,
          orgAddress,
          setOrgAddress,
          orgLogo,
          setOrgLogo,
          customClientData,
          setCustomClientData,
          editOrgData,
          orgModules,
          setOrgModules,
        }}
      />

      <ResetPasswordModal
        resetPasswordModal={resetPasswordModal}
        loading={false}
        handleResetPassword={handleResetPassword}
        handleResetPasswordModalClose={handleResetPasswordModalClose}
        data={{
          resetPassword,
          setResetPassword,
          resetPasswordConfirm,
          setResetPasswordConfirm,
          resetPasswordData,
        }}
      />

      <ToggleOrgActive
        toggleOrgModal={toggleOrgModal}
        deleteOrgData={deleteOrgData}
        loading={false}
        handleToggleModalClose={handleToggleModalClose}
        handleOrgToggle={handleOrgToggle}
      />

      <DeleteOrgModal
        deleteOrgModal={deleteOrgModal}
        loading={deleteOrg && deleteOrg.loading}
        handleDeleteOrg={handleDeleteOrg}
        handleDeleteOrgModalClose={handleDeleteOrgModalClose}
        data={{
          deleteEmail,
          setDeleteEmail,
          deleteOrgData,
        }}
      />
    </Content>
  );
};

export default OrgsScreen;
